module.exports = __webpack_public_path__ + "img/lite-small.46441b56.svg";